var _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfiansaFeliz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.79,18.21c-5.15-5.15-12-7.99-19.29-7.99s-14.14,2.84-19.29,7.99-7.99,12-7.99,19.29,2.84,14.14,7.99,19.29,12,7.99,19.29,7.99,14.14-2.84,19.29-7.99c5.15-5.15,7.99-12,7.99-19.29s-2.84-14.14-7.99-19.29Zm-2.1,36.48c-4.59,4.59-10.7,7.12-17.19,7.12s-12.6-2.53-17.19-7.12c-4.59-4.59-7.12-10.7-7.12-17.19s2.53-12.6,7.12-17.19c4.59-4.59,10.7-7.12,17.19-7.12s12.6,2.53,17.19,7.12c4.59,4.59,7.12,10.7,7.12,17.19s-2.53,12.6-7.12,17.19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.24,
    cy: 30.01,
    r: 3.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.76,
    cy: 30.01,
    r: 3.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.5,43.62c-2.03,0-3.69-1.66-3.69-3.69h-2.97c0,3.67,2.99,6.66,6.66,6.66s6.66-2.99,6.66-6.66h-2.97c0,2.04-1.66,3.69-3.69,3.69Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiansaFeliz);
export default __webpack_public_path__ + "static/media/confiansa_feliz.dc4cbeeef6066ea5d6c099c26751cea9.svg";
export { ForwardRef as ReactComponent };